module.exports = __webpack_public_path__ + "media/images/front/icons/email-c17c36f5076c02ad0c9bbdff372f1310.png";